<template>

  <section

    v-if="competition && hasContent"

    class="tc-panel fanbase-panel fanbase-panel--wide"

    aria-labelledby="tournament-competition-heading"

  >

    <div class="fanbase-panel__head">

      <span class="fanbase-panel__icon" aria-hidden="true">

        <i class="fa-solid fa-ranking-star" />

      </span>

      <div>

        <h2 id="tournament-competition-heading" class="fanbase-panel__title">

          {{ panelTitle }}

        </h2>

        <p class="fanbase-panel__sub">

          {{ panelSubtitle }}

        </p>

      </div>

    </div>



    <div v-if="showGroups && groupLabels.length" class="tc-legend" role="note">

      <span class="tc-legend__pill">

        <i class="fa-solid fa-trophy" aria-hidden="true" />

        Win {{ rules.win }} pts

      </span>

      <span class="tc-legend__pill">

        <i class="fa-solid fa-handshake" aria-hidden="true" />

        Draw {{ rules.draw }} pt

      </span>

      <span

        v-if="competition.has_group_stage"

        class="tc-legend__pill tc-legend__pill--qualify"

      >

        <i class="fa-solid fa-arrow-up" aria-hidden="true" />

        Top 2 advance

      </span>

    </div>



    <div v-if="showGroups && groupLabels.length" class="tc-groups">

      <article

        v-for="groupLabel in groupLabels"

        :key="groupLabel"

        class="tc-group-card"

      >

        <header class="tc-group-card__head">

          <h3 class="tc-group-card__title">

            <i class="fa-solid fa-layer-group" aria-hidden="true" />

            {{ groupLabel }}

          </h3>

          <span class="tc-group-card__count">

            {{ competition.group_standings[groupLabel].length }} teams

          </span>

        </header>



        <div class="tc-table-wrap">

          <table class="tc-table">

            <thead>

              <tr>

                <th scope="col" class="tc-table__pos">#</th>

                <th scope="col" class="tc-table__team">Team</th>

                <th scope="col" title="Played">P</th>

                <th scope="col" title="Won">W</th>

                <th scope="col" title="Drawn">D</th>

                <th scope="col" title="Lost">L</th>

                <th scope="col" title="Goals for">GF</th>

                <th scope="col" title="Goals against">GA</th>

                <th scope="col" title="Goal difference">GD</th>

                <th scope="col" class="tc-table__pts" title="Points">Pts</th>

              </tr>

            </thead>

            <tbody>

              <tr

                v-for="row in competition.group_standings[groupLabel]"

                :key="`${groupLabel}-${row.team_id}`"

                class="tc-table__row"

                :class="rowClass(row)"

              >

                <td class="tc-table__pos">

                  <span class="tc-pos-badge" :class="posBadgeClass(row.position)">

                    {{ row.position }}

                  </span>

                </td>

                <td class="tc-table__team">

                  <div class="tc-team-cell">

                    <span class="tc-team-logo" aria-hidden="true">

                      <img

                        v-if="teamLogo(row)"

                        :src="teamLogo(row)"

                        :alt="''"

                        loading="lazy"

                        decoding="async"

                        @error="onLogoError(row.team_id)"

                      />

                      <i v-else class="fa-solid fa-shield-halved" />

                    </span>

                    <span class="tc-team-name">{{ row.team_name }}</span>

                    <span

                      v-if="row.position <= 2 && competition.group_stage_complete"

                      class="tc-qualify-tag"

                      title="Qualifies for knockout"

                    >

                      Q

                    </span>

                  </div>

                </td>

                <td>{{ row.played }}</td>

                <td class="tc-stat--win">{{ row.won }}</td>

                <td>{{ row.drawn }}</td>

                <td class="tc-stat--loss">{{ row.lost }}</td>

                <td>{{ row.goals_for }}</td>

                <td>{{ row.goals_against }}</td>

                <td :class="gdClass(row.goal_difference)">

                  {{ formatGd(row.goal_difference) }}

                </td>

                <td class="tc-table__pts">

                  <strong>{{ row.points }}</strong>

                </td>

              </tr>

            </tbody>

          </table>

        </div>

      </article>

    </div>



    <div v-if="showKnockout && knockoutItems.length" class="tc-knockout">

      <div class="tc-ko-grid">

        <article

          v-for="item in knockoutItems"

          :key="item.fixture_id"

          class="tc-ko-card"

          :class="`tc-ko-card--${stageClass(item.bracket_stage)}`"

        >

          <p class="tc-ko-card__level">{{ formatRoundLabel(item.round_label) }}</p>



          <div class="tc-ko-card__matchup">

            <div

              class="tc-ko-card__team"

              :class="{ 'tc-ko-card__team--winner': isWinner(item, 'home') }"

            >

              <span class="tc-team-logo tc-team-logo--sm" aria-hidden="true">

                <img

                  v-if="bracketLogo(item, 'home')"

                  :src="bracketLogo(item, 'home')"

                  :alt="''"

                  loading="lazy"

                />

                <i v-else class="fa-solid fa-shield-halved" />

              </span>

              <span class="tc-ko-card__name">{{ displayTeamName(item, 'home') }}</span>

              <span v-if="hasScore(item)" class="tc-ko-card__score">{{ item.home_score }}</span>

            </div>



            <div class="tc-ko-card__vs" aria-hidden="true">

              <span class="tc-ko-card__vs-label">VS</span>

            </div>



            <div

              class="tc-ko-card__team tc-ko-card__team--away"

              :class="{ 'tc-ko-card__team--winner': isWinner(item, 'away') }"

            >

              <span v-if="hasScore(item)" class="tc-ko-card__score">{{ item.away_score }}</span>

              <span class="tc-ko-card__name">{{ displayTeamName(item, 'away') }}</span>

              <span class="tc-team-logo tc-team-logo--sm" aria-hidden="true">

                <img

                  v-if="bracketLogo(item, 'away')"

                  :src="bracketLogo(item, 'away')"

                  :alt="''"

                  loading="lazy"

                />

                <i v-else class="fa-solid fa-shield-halved" />

              </span>

            </div>

          </div>

        </article>

      </div>

    </div>

  </section>

</template>



<script>

export default {

  name: "TournamentCompetitionPanel",



  props: {

    competition: {

      type: Object,

      default: null,

    },

    /** Optional fallback map: team_id -> logo_url */

    teamLogos: {

      type: Object,

      default: () => ({}),

    },

  },



  data() {

    return {

      brokenLogos: {},

    };

  },



  computed: {

    showGroups() {

      if (this.competition?.show_group_standings === false) return false;

      if (this.competition?.show_group_standings === true) {

        return this.groupLabels.length > 0;

      }

      return this.groupLabels.length > 0;

    },



    showKnockout() {

      if (this.competition?.show_knockout_bracket === false) return false;

      return this.knockoutItems.length > 0;

    },



    groupLabels() {

      const standings = this.competition?.group_standings || {};

      return Object.keys(standings).sort();

    },



    knockoutItems() {

      return this.competition?.knockout_bracket || [];

    },



    hasContent() {

      return (this.showGroups && this.groupLabels.length > 0)

        || (this.showKnockout && this.knockoutItems.length > 0);

    },



    panelTitle() {

      if (this.showGroups && this.groupLabels.length && !this.showKnockout) {

        return "Group standings";

      }

      if (!this.showGroups && this.showKnockout) {

        return "Knockout";

      }

      return "Standings & knockout";

    },



    panelSubtitle() {

      if (this.showGroups && !this.showKnockout) {

        return `Tables update as matches are played · ${this.pointsLabel}`;

      }

      if (!this.showGroups && this.showKnockout) {

        return "Knockout fixtures and results";

      }

      return `Group tables and knockout bracket · ${this.pointsLabel}`;

    },



    rules() {

      return this.competition?.points_rules || { win: 3, draw: 1, loss: 0 };

    },



    pointsLabel() {

      return `Win ${this.rules.win} pts · Draw ${this.rules.draw} pt · Loss ${this.rules.loss} pt`;

    },

  },



  methods: {

    hasScore(item) {

      return item.home_score != null && item.away_score != null;

    },



    onLogoError(teamId) {

      this.brokenLogos = { ...this.brokenLogos, [teamId]: true };

    },



    teamLogo(row) {

      const id = row.team_id;

      if (this.brokenLogos[id]) return null;

      return row.logo_url || this.teamLogos[id] || null;

    },



    bracketLogo(item, side) {

      const id = side === "home" ? item.home_team_id : item.away_team_id;

      if (this.brokenLogos[id]) return null;

      const fromItem =

        side === "home" ? item.home_team_logo_url : item.away_team_logo_url;

      return fromItem || this.teamLogos[id] || null;

    },



    displayTeamName(item, side) {

      const name = side === "home" ? item.home_team_name : item.away_team_name;

      if (item.teams_tbd || name === "TBD") return "TBD";

      return name;

    },



    formatRoundLabel(label) {

      if (!label) return "Knockout";

      const base = String(label).split("·")[0].trim();

      return base

        .replace(/-/g, " ")

        .replace(/\b\w/g, (char) => char.toUpperCase());

    },



    rowClass(row) {

      if (row.position === 1) return "tc-table__row--leader";

      if (row.position <= 2) return "tc-table__row--qualify";

      return "";

    },



    posBadgeClass(position) {

      if (position === 1) return "tc-pos-badge--gold";

      if (position === 2) return "tc-pos-badge--silver";

      return "";

    },



    formatGd(value) {

      const n = Number(value) || 0;

      return n > 0 ? `+${n}` : String(n);

    },



    gdClass(value) {

      const n = Number(value) || 0;

      if (n > 0) return "tc-gd--pos";

      if (n < 0) return "tc-gd--neg";

      return "tc-gd--zero";

    },



    stageClass(stage) {

      const s = (stage || "knockout").toLowerCase();

      if (s.includes("final") && !s.includes("semi")) return "final";

      if (s.includes("semi")) return "semi";

      if (s.includes("quarter")) return "quarter";

      return "knockout";

    },



    isWinner(item, side) {

      if (!this.hasScore(item) || !item.winner_team_id) return false;

      const teamId = side === "home" ? item.home_team_id : item.away_team_id;

      return Number(item.winner_team_id) === Number(teamId);

    },

  },

};

</script>



<style scoped src="./tournamentCompetition.css"></style>

